export default __webpack_public_path__ + "media/siteware_admin/favicon-96-f10426cf1c24b94c8b35807f1b0a517d.png";